<template>
    <!--解决方案-->
    <div class="solution">
        <Banner/>
        <!--充电运营管理服务系统-->
        <div class="charge">
            <div class="charge_img">
                <img src="@/asstes/solution/first.png">
            </div>
            <div class="charge_info">
                <div class="charge_info_title">充电运营管理服务系统</div>
                <div class="charge_info_pgh">
                    社区充电、露营、集体充电<br/>
                    <br/>
                    基于当前互联网信息技术，建立一套完善的多方协调沟通机制，为新能源汽车用户提供一站式服务，节省用户及车企人员大量时间与精力，实现充电桩安装、运营、售后、共享可视化管理，整合资源、信息共通，形成高效率、快执行的加速发展格局，对促进电动汽车产业化发展以及能源环境保护,都有着十分重要的现实意义。</div>
                <div class="charge_info_more" @click="chargeMore">了解更多</div>
            </div>

            <div class="charge_pc">
                <img src="@/asstes/solution/first_dec.png">
            </div>

        </div>

        <!--换电用车运营管理系统-->
        <div class="exchange_pc">
            <div class="exchange_info">
                <div class="exchange_info_title">换电商用车运营管理系统</div>
                <div class="exchange_info_pgh">
                    换电重卡、换电资产管理、换电站、电池银行<br/>
                    <br/>
                    针对换电基础设施如重卡、充换电站、电池等通过车载T-BOX、站控终端设备等实时采集数据，与平台对接，最终实现智能管理与数据分析。通过资产管控获得的基础数据构建智能分析模型，分析出经营管理的不足，实现车辆、换电站等资产智能排班调度管理，为后续精细化运营提供数据支撑，推动构建换电设施生态圈。</div>
                <div class="exchange_info_more">资产运营、度电结算、区域统计、设备管理、车辆运营日报、仪表盘</div>
            </div>
            <div class="exchange_img">
                <img src="@/asstes/solution/second.png" style="width: 100%;">
            </div>

        </div>
        <div class="exchange_app">
            <div class="exchange_img">
                <img src="@/asstes/solution/second.png" style="width: 100%;">
            </div>
            <div class="exchange_info">
                <div class="exchange_info_title">换电商用车运营管理系统</div>
                <div class="exchange_info_pgh">
                    换电重卡、换电资产管理、换电站、电池银行<br/>
                    <br/>
                    针对换电基础设施如重卡、充换电站、电池等通过车载T-BOX、站控终端设备等实时采集数据，与平台对接，最终实现智能管理与数据分析。通过资产管控获得的基础数据构建智能分析模型，分析出经营管理的不足，实现车辆、换电站等资产智能排班调度管理，为后续精细化运营提供数据支撑，推动构建换电设施生态圈。</div>
                <div class="exchange_info_more">资产运营、度电结算、区域统计、设备管理、车辆运营日报、仪表盘</div>
            </div>
        </div>

        <!--分布式储能电站运营系统-->
        <div class="distributed">
            <div class="distributed_img">
                <img src="@/asstes/solution/third.png" style="width: 100%;">
            </div>
            <div class="distributed_info">
                <div class="distributed_info_title">分布式储能电站运营管理系统</div>
                <div class="distributed_info_pgh">
                    共享储能、风光新能源平滑优化、用户侧用能移峰填谷、传统火电能源调频<br/>
                    <br/>
                    在大力推行供给侧结构性改革和新电改的行业背景下，依托新能源产业优势，构建以储能为核心的综合能源运营与服务体系，有助于提高需求侧用电能效管理水平。通过能源管理和监控的信息化、可视化，提高资源配置效率，以互联网、云计算管理手段，盘活清洁电力资源，形成完整的清洁能源开发、运营与服务体系。</div>
                <div class="distributed_info_more">系统管理、运维管理、设备管理、项目管理、经营分析、主数据</div>
                <div class="distributed_info_img">
                    <img src="@/asstes/solution/first_dec.png" style="width: 100%;">
                </div>
            </div>

        </div>

        <!--城市级绿色出行服务平台-->
        <div class="city_pc">
            <div class="city_info">
                <div class="city_info_title">城市级绿色出行服务平台</div>
                <div class="city_info_pgh">
                    个人出行、公共交通出行、自主低碳出行、绿色定制出行<br/>
                    <br/>
                    打造节能、高效、可持续发展的城市绿色出行交通解决方案，通过对现有城市电动汽车运营网络的集中式平台化运营和管理，实现城市能源友好、环境友好和居民出行友好交通模式的有机结合，进一步实现城市交通的经济可持续性、社会可持续性和环境可持续性发展。</div>
                <div class="city_info_more" @click="greenCityMore">了解更多</div>
            </div>
            <div class="city_img">
                <img src="@/asstes/solution/fourth.png" style="width: 100%;">
            </div>

        </div>
        <div class="city_app">
            <div class="city_img">
                <img src="@/asstes/solution/fourth.png" style="width: 100%;">
            </div>
            <div class="city_info">
                <div class="city_info_title">城市级绿色出行服务平台</div>
                <div class="city_info_pgh">
                    个人出行、公共交通出行、自主低碳出行、绿色定制出行<br/>
                    <br/>
                    打造节能、高效、可持续发展的域市绿色出行交通解决方案，通过对现有城市电动汽车运营网络的集中式平台化运营和管理，实现城市能源友好、环境友好和居民出行友好交通模式的有机结合，进一步实现城市交通的经济可持续性、社会可持续性和环境可持续性发展。</div>
                <div class="city_info_more" @click="greenCityMore">了解更多</div>
            </div>
        </div>
    </div>
</template>

<script>
    import Banner from './banner'
    export default {
        components: {
            Banner:resolve => {
                require(['./banner'], resolve)
            },
        },
        methods:{
            chargeMore(){
                let that = this;
                that.$router.push({path: '/charge'})
            },
            greenCityMore(){
                let that = this;
                that.$router.push({path: '/greenCity'})
            },
        }
    }
</script>

<style lang="less" scoped>
    @media only screen and (max-width: 750px){
        .solution{
            .exchange_app, .city_app{
                background-color: #F9FBFC;
            }
            .charge, .exchange_app , .distributed, .city_app{
                display: flex;
                flex-wrap: wrap;
                justify-content: center;
                align-items: center;
                text-align: center;
                padding:  216px 144px 216px 144px;
                box-sizing: border-box;

                .charge_img, .exchange_img ,.distributed_img, .city_img{
                    width: 100%;
                    img{
                        width: 100%;
                    }
                }
                .charge_info, .exchange_info, .distributed_info, .city_info{
                    padding-top: 180px;
                    box-sizing: border-box;

                    .charge_info_title, .exchange_info_title, .distributed_info_title, .city_info_title{
                        font-weight: 600;
                        color: #373A5A;
                        font-size: 79.2px;
                        padding-bottom: 86.4px;
                        box-sizing: border-box;
                    }
                    .charge_info_pgh, .exchange_info_pgh, .distributed_info_pgh, .city_info_pgh{
                        text-align: left;
                        font-size: 50.4px;
                        line-height: 90px;
                        padding-bottom: 72px;
                        box-sizing: border-box;
                    }
                    .charge_info_more, .exchange_info_more, .distributed_info_more, .city_info_more{
                        text-align: left;
                        font-weight: 500;
                        color: #07CFA2;
                        font-size: 43.2px;
                        line-height: 57.6px;
                    }
                }

                .charge_pc, .distributed_info_img{
                    display: none;
                }

            }
            .exchange_pc, .city_pc{
                display: none;
            }
        }
    }

    @media only screen and (min-width: 750px) {
        .solution {
            margin-top: -56px;
            z-index: 80;

            .charge {
                padding: 64px 120px;
                box-sizing: border-box;
                display: flex;
                justify-content: center;
                align-items: flex-end;

                .charge_img {
                    padding-right: 80px;
                    box-sizing: border-box;
                    img{
                        width: 100%;
                    }
                }

                .charge_info {
                    color: #373A5A;
                    padding-right: 24px;
                    box-sizing: border-box;

                    .charge_info_title {
                        font-size: 36px;
                        font-weight: 600;
                        color: #373A5A;
                        line-height: 50px;
                        padding-bottom: 32px;
                        box-sizing: border-box;
                    }

                    .charge_info_subtitle, .charge_info_pgh {
                        max-width: 380px;
                        font-weight: 400;
                        color: #000000;
                        line-height: 32px;
                    }

                    .charge_info_subtitle {
                        font-size: 15px;
                        padding-bottom: 16px;
                        box-sizing: border-box;
                    }

                    .charge_info_pgh {
                        font-size: 12px;
                        padding-bottom: 10px;
                        box-sizing: border-box;
                    }

                    .charge_info_more {
                        color: #07CFA2;
                        font-size: 10px;
                    }

                    .charge_info_more:hover {
                        cursor: pointer;
                    }

                    .charge_pc{
                        img{
                            width: 100%;
                        }
                    }
                }
            }

            .exchange_pc {
                padding: 120px;
                box-sizing: border-box;
                display: flex;
                justify-content: center;
                align-items: center;
                background-color: #F9FBFC;
                .exchange_img {
                    width: calc(100% - 40px - 400px);
                    padding-left: 40px;
                    box-sizing: border-box;
                }

                .exchange_info {
                    color: #373A5A;

                    .exchange_info_title {
                        max-width: 400px;
                        font-size: 36px;
                        font-weight: 600;
                        line-height: 50px;
                        padding-bottom: 32px;
                        box-sizing: border-box;
                    }

                    .exchange_info_subtitle, .exchange_info_pgh {
                        max-width: 400px;
                        font-weight: 400;
                        color: #000000;
                        line-height: 32px;
                    }

                    .exchange_info_subtitle {
                        font-size: 15px;
                        padding-bottom: 24px;
                        box-sizing: border-box;
                    }

                    .exchange_info_pgh {
                        font-size: 12px;
                        padding-bottom: 24px;
                        box-sizing: border-box;
                    }

                    .exchange_info_more {
                        font-size: 12px;
                        color: #07CFA2;
                    }
                }
            }
            .exchange_app{
                display: none;
            }

            .distributed {
                padding: 100px 120px;
                box-sizing: border-box;
                display: flex;
                justify-content: center;
                align-items: center;

                .distributed_img {
                    width: calc(50% - 48px);
                    padding-right: 48px;
                    box-sizing: border-box;
                }

                .distributed_info {
                    color: #373A5A;
                    position: relative;

                    .distributed_info_title {
                        font-size: 36px;
                        font-weight: 600;
                        color: #373A5A;
                        line-height: 50px;
                        padding-bottom: 32px;
                        box-sizing: border-box;
                    }

                    .distributed_info_subtitle, .distributed_info_pgh {
                        max-width: 500px;
                        font-weight: 400;
                        color: #000000;
                        line-height: 29px;
                    }

                    .distributed_info_subtitle {
                        font-size: 15px;
                        padding-bottom: 24px;
                        box-sizing: border-box;
                    }

                    .distributed_info_pgh {
                        font-size: 12px;
                        padding-bottom: 24px;
                        box-sizing: border-box;
                    }

                    .distributed_info_more {
                        font-size: 12px;
                        color: #07CFA2;
                    }

                    .distributed_info_img {
                        position: absolute;
                        right: 0;
                        top: 0;
                    }
                }
            }

            .city_pc {
                padding: 48px 120px 90px 120px;
                box-sizing: border-box;
                display: flex;
                justify-content: center;
                align-items: center;
                background-color: #F9FBFC;

                .city_img {
                    width: calc(100% - 100px - 400px);
                    padding-left: 100px;
                    box-sizing: border-box;
                }

                .city_info {
                    color: #373A5A;

                    .city_info_title {
                        max-width: 400px;
                        font-size: 36px;
                        font-weight: 600;
                        line-height: 50px;
                        padding-bottom: 32px;
                        box-sizing: border-box;
                    }

                    .city_info_subtitle, .city_info_pgh {
                        max-width: 400px;
                        font-weight: 400;
                        color: #000000;
                        line-height: 29px;
                    }

                    .city_info_subtitle {
                        font-size: 15px;
                        padding-bottom: 24px;
                        box-sizing: border-box;
                    }

                    .city_info_pgh {
                        font-size: 12px;
                        padding-bottom: 24px;
                        box-sizing: border-box;
                    }

                    .city_info_more {
                        font-size: 12px;
                        color: #07CFA2;
                    }

                    .city_info_more:hover {
                        cursor: pointer;
                    }
                }
            }
            .city_app{
                display: none;
            }

        }
    }
</style>